import React, { useState, useEffect, useRef } from 'react';
import robotAssistant from '../assets/img/chatbot.png';
import { IoMdSend } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { FaUser, FaRobot } from "react-icons/fa";
import { baseUrl } from '../config';



const Chat = () => {
    const [messages, setMessages] = useState(() => {
        const savedMessages = localStorage.getItem('chatMessages');
        return savedMessages ? JSON.parse(savedMessages) : [{ text: "Welcome to the Pilobuddy Chat! How may I assist you today?", isBot: true, timestamp: new Date() }];
    });
    const [input, setInput] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const chatRef = useRef(null);
    const messagesEndRef = useRef(null);

    const handleSend = () => {
        if (input.trim() === "") return;

        const newMessages = [...messages, { text: input, isBot: false, timestamp: new Date() }];
        setMessages(newMessages);
        setInput("");

        // Simulate bot response
        setIsTyping(true);
        setTimeout(() => {
            setMessages(prevMessages => [
                ...prevMessages,
                { text: "I'm processing your request. How else can I assist you in the world of entertainment?", isBot: true, timestamp: new Date() }
            ]);
            setIsTyping(false);
        }, 1000);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    const handleClickOutside = (event) => {
        if (chatRef.current && !chatRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    const handleClearChat = () => {
        setMessages([]);
        localStorage.removeItem('chatMessages');
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        localStorage.setItem('chatMessages', JSON.stringify(messages));
    }, [messages]);

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        return `${date.getHours()}:${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`;
    };

    return (
        <div
            id='chat'
            ref={chatRef}
            style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                minWidth: '40px',
                minHeight: '40px',
                height: 'fit-content',
                width: 'fit-content',
                zIndex: 100,
            }}
        >
            {!isOpen && (
                <button
                    onClick={() => setIsOpen(true)}
                    id="messageIcon"
                    style={{
                        cursor: 'pointer',
                        fontSize: '50px',
                        zIndex: 100,
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        color: '#008080',
                        transition: 'color 0.3s ease',
                        textShadow: '0 0 10px rgba(0, 128, 128, 0.5)',
                        background: 'none',
                        border: 'none',
                    }}
                >
                    <img src={robotAssistant} alt="Robot Assistant" style={{ width: '50px', height: '50px' }} />
                </button>
            )}
            {isOpen && (
                <div id="chatBox" style={{
                    height: '60vh',
                    width: '350px',
                    margin: 'auto',
                    position: 'absolute',
                    bottom: '80px',
                    right: '20px',
                    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.3)',
                    backgroundColor: 'rgba(26, 26, 26, 0.8)', // Transparent background
                    borderRadius: '15px',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    border: '2px solid #008080',
                }}>
                    <div style={{
                        backgroundColor: '#008080',
                        color: '#1A1A1A',
                        padding: '10px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '2px solid #1A1A1A',
                    }}>
                        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', margin: 0 }}>PiloAssistant</h2>
                        <div>
                            <button onClick={handleClearChat} style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '10px' }}>
                                Clear
                            </button>
                            <button onClick={() => setIsOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                <MdClose size={20} />
                            </button>
                        </div>
                    </div>
                    <div id="messages" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        overflowY: 'auto',
                        padding: '10px',
                        gap: '10px',
                    }}>
                        {messages.map((msg, index) => (
                            <div
                                key={index}
                                style={{
                                    backgroundColor: msg.isBot ? '#2C3E50' : '#34495E',
                                    borderRadius: '15px',
                                    maxWidth: '80%',
                                    padding: '10px',
                                    color: '#FFFFFF',
                                    alignSelf: msg.isBot ? 'flex-start' : 'flex-end',
                                    boxShadow: '0px 2px 5px rgba(0, 128, 128, 0.2)',
                                    opacity: 0,
                                    animation: `fadeIn 0.5s ease forwards ${index * 0.1}s`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                }}
                            >
                                {msg.isBot ? <FaRobot /> : <FaUser />}
                                <div>
                                    <p style={{ margin: 0 }}>{msg.text}</p>
                                    <span style={{ fontSize: '0.8rem', color: '#B0B0B0', marginTop: '5px', display: 'block' }}>
                                        {formatTimestamp(msg.timestamp)}
                                    </span>
                                </div>
                            </div>
                        ))}
                        {isTyping && (
                            <div style={{
                                alignSelf: 'flex-start',
                                backgroundColor: '#2C3E50',
                                borderRadius: '15px',
                                maxWidth: '80%',
                                padding: '10px',
                                color: '#FFFFFF',
                                boxShadow: '0px 2px 5px rgba(0, 128, 128, 0.2)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                            }}>
                                <div className="typing-indicator">
                                    <span></span><span></span><span></span>
                                </div>
                            </div>
                        )}
                        <div ref={messagesEndRef} />
                    </div>
                    <div id="input" style={{
                        display: 'flex',
                        gap: '10px',
                        padding: '10px',
                        borderTop: '1px solid #008080',
                    }}>
                        <textarea
                            style={{
                                flexGrow: 1,
                                padding: '10px',
                                border: '1px solid #008080',
                                backgroundColor: '#2C3E50',
                                color: '#FFFFFF',
                                borderRadius: '10px',
                                resize: 'none',
                                transition: 'border-color 0.3s ease',
                            }}
                            placeholder="Type your message..."
                            rows="2"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                        <button
                            id="send"
                            onClick={handleSend}
                            style={{
                                backgroundColor: '#008080',
                                color: '#1A1A1A',
                                padding: '10px',
                                borderRadius: '50%',
                                border: 'none',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <IoMdSend size={24} />
                        </button>
                    </div>
                </div>
            )}
            <style>{`
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
    }
    .typing-indicator span {
        display: inline-block;
        width: 8px;
        height: 8px;
        margin: 0 2px;
        background-color: #FFFFFF;
        border-radius: 50%;
        animation: typing 1s infinite;
    }
    .typing-indicator span:nth-child(2) {
        animation-delay: 0.2s;
    }
    .typing-indicator span:nth-child(3) {
        animation-delay: 0.4s;
    }
    @keyframes typing {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-5px); }
    }
    #messages::-webkit-scrollbar { width: 8px; }
    #messages::-webkit-scrollbar-track { background: rgba(26, 26, 26, 0.5); }
    #messages::-webkit-scrollbar-thumb { background-color: #008080; border-radius: 4px; }
    #chatBox::before {
        content: "";
        position: absolute;
        top: -10px;
        left: 20px;
        right: 20px;
        height: 20px;
        background-image: repeating-linear-gradient(
            90deg,
            #008080,
            #008080 10px,
            rgba(26, 26, 26, 0.8) 10px,
            rgba(26, 26, 26, 0.8) 20px
        );
        border-radius: 10px 10px 0 0;
    }
    @media only screen and (min-width: 660px) {
        #chatBox { width: 400px !important; }
    }
`}</style>
        </div>
    );
};

export default Chat;
